import React, { useEffect, useRef } from "react";

interface CookieConsentProps {
  lang: string;
}

const CookieConsent: React.FC<CookieConsentProps> = ({ lang }) => {
  const reddotRef = useRef<HTMLDivElement | null>(null);

  const displayTextTh = {
    modal_cookie_consent: {
      title:
        '<div class="ot-pc-logo" role="img" aria-label="โลโก้บริษัท"><img alt="โลโก้บริษัท" src="https://investor.scgpackaging.com/storage/content/scgp-colorful.svg"></div>การตั้งค่าความเป็นส่วนตัว'
    }
  };

  const displayTextEn = {
    modal_cookie_consent: {
      title:
        '<div class="ot-pc-logo" role="img" aria-label="Company Logo"><img alt="Company Logo" src="https://investor.scgpackaging.com/storage/content/scgp-colorful.svg"></div>Privacy Preference Center'
    }
  };

  const displayText = lang === "en" ? displayTextEn : displayTextTh;

  useEffect(() => {
    const reddotElement = reddotRef.current;

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === "childList") {
          const titleElement = document.querySelector(".cm-header > .title");
          if (
            titleElement &&
            titleElement.innerHTML !== displayText.modal_cookie_consent.title
          ) {
            titleElement.innerHTML = displayText.modal_cookie_consent.title;
          }

          const linkElement = document.querySelector(
            "#reddot > div > div > div.cm-modal.cm-reddot > div.cm-footer > p > a"
          );
          if (linkElement) {
            linkElement.textContent = "SCG PACKAGING";
            linkElement.setAttribute("href", "https://www.scgpackaging.com/th");
          }
        }
      });
    });

    if (reddotElement) {
      observer.observe(reddotElement, {
        childList: true,
        subtree: true
      });

      // Show the cookie consent window
      reddotElement.style.display = "block";
    }

    return () => {
      // Cleanup observer when the component is unmounted
      if (reddotElement) {
        observer.disconnect();
      }
    };
  }, [displayText]);

  return (
    <div id="reddot" ref={reddotRef}>
      {/* This will be the area where the DOM changes will be observed */}
    </div>
  );
};

export default CookieConsent;
